export const MESSAGE 				= "MESSAGE";
export const MESSAGE_REQUEST 	= "MESSAGE_REQUEST";
export const MESSAGE_FAILED	 	= "MESSAGE_FAILED";
export const MESSAGE_SUCCESS 	= "MESSAGE_SUCCESS";




// WEBPACK FOOTER //
// ./src/app/redux/constants/b2b.js